import { SVGProps } from "react";

export const JiraServiceManagementMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="Vector"
                d="M18.2037 13.0449L25.5755 13.0819C26.5059 13.0819 27.0427 14.19 26.5059 14.9658L15.6272 30.0001C12.1918 27.3774 11.5119 22.3536 14.0527 18.8075L18.2037 13.0449Z"
                fill="#1868DB"
            />
            <path
                id="Vector_2"
                d="M14.0531 18.8074L6.71708 18.7704C5.78667 18.7704 5.24989 17.6623 5.78667 16.8865L16.5938 2C20.0292 4.62269 20.7091 9.64644 18.1684 13.1926L14.0531 18.8074Z"
                fill="#1868DB"
            />
        </g>
    </svg>
);
